<template>
  <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col md="2">
            <b-form-group>
              * Please Set Range
            </b-form-group>
          </b-col>
          <b-col md="5">
            <b-form-group>
              <b-form>
              <label for="opt_date">From </label>
                <date-picker style="width: 300px" v-model="From" :lang="lan" :first-day-of-week="1" @change="report"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="5">
            <b-form-group>
              <b-form>
              <label for="opt_date">To </label>
                <date-picker style="width: 300px" v-model="To" :lang="lan" :first-day-of-week="1" @change="report"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <!-- <b-col md="1">
            <b-form-group>
              <b-form inline>
              <b-button size="sm" variant="primary" @click="report"> Search </b-button>
              </b-form>
            </b-form-group>
          </b-col> -->
        </b-row>
        <!-- <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="report"> Search </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> Initialization </b-button>
          <b-button size="sm" variant="success" id="excelHtml5" @click="printNow"> PRINT </b-button>
        </b-form-group> -->
      </b-card>
      <div style="display:block; margin-left:auto; margin-right:auto;"><br>
      <h1 align="center" style="font-weight:700; font-size:50px">WSFinder Report</h1>
      </div>
      <img style="display:block; margin-left:auto; margin-right:auto;" src="./world_map.png"/>
      <b-card>
        <b-form-group>
        Copyrights<br><br>
        Copyright ⓒ 2019 F1Security Inc.<br>
        10F, #1003, 128, Gasan Digital 1-ro, Geumcheon-gu, Seoul, Korea (08507)<br>
        All Rights Reserved.<br><br>
        This report has been prepared to provide information on the results of malicious code check for the period to the 'WSFinder' representative<br>
        This document is copyrighted by F1Security Inc. It is a work protected by copyright law in Korea
        We inform you that the contents of this document cannot be quoted in whole or in part without the consent of the document of the F1Security Inc.<br>
        Any use without consent may be punished by the relevant laws<br>
        This document may contain technical inaccuracies or typographical errors
        Please note that the contents of this document or the program can be modified or changed without prior notice
        </b-form-group>
      </b-card>
       <b-form-group>
          <h4 style="page-break-before:always;">목차</h4>
        </b-form-group>
          <b-card>
            <b-form-group>
              1. Summary - Period Key Content Summary<br>
              1.1.{{model.name || 'WSFinder'}} Information<br>
              1.2. Check Statistics Information<br>
              1.3. WebShell Detect Information<br>
            &lt;Figure 1. Check Statistics graph&gt;<br>
            &lt;Table 1. Account Basic Information&gt;<br>
            &lt;Table 2. Check Statistics Information&gt;<br>
            &lt;Table 3. Agent Check Table&gt;<br>
            </b-form-group>
          </b-card>
        <b-form-group>
          <h5>1. Summary - Period Key Content Summary</h5>
        </b-form-group>
         <b-form-group>
          <h5>1.1. Information</h5>
          <small>The default information for the user registration site. next&lt;table 1. Site Basic Information&gt;This allows you to check the site name, business name, site URL, FQDN, administrator name, DNS information, number of registered domains (total), and check policy.</small>
        </b-form-group>
          <b-card>
            <template slot="header">
               &lt;Table 1. Site Basic Information&gt;
            </template>
            <div class="panel-body">
              <div>
                <table style="width:100%; max-width:100%; border:1px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center;">Business name</th>
                      <th style=" width:300px; padding:4px; background-Color:#f0f3f5; text-align: center;" v-if="model">{{user && user.groupname || 'WSFinder'}}</th>
                      <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center;">Registered Agents Count</th>
                      <th style=" width:300px; padding:4px; background-Color:#f0f3f5; text-align: center;" v-if="model">{{server && server.use || 0}} 건</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        <b-form-group>
          <h5>1.2. Check Statistics Information</h5>
          <small>WebShell Check Statistics Information. Next &lt;Table 3. Check Statistics Information&gt;</small>
        </b-form-group>
      <b-card>
      <template slot="header">
         &lt;Figure 1. Check statistics graph&gt;
      </template>
      <b-row>
        <b-col sm="6" lg="4">
          <h6 class="mb-0">registration agent</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="use_data"/>
        </b-col>
        <b-col sm="6" lg="4">
          <h6 class="mb-0">Detection count</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="detect_data"/>
        </b-col>
        <b-col sm="6" lg="4">
          <h6 class="mb-0">Agent Check Count</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="result_data"/>
        </b-col>
      </b-row>
      </b-card>
       <b-form-group>
        <h5>1.4. WebShell Detect Information</h5>
        <small>It's a list of only the actual number of cases detected.</small><br>
         <small>
         - Regex : Detected as a regular expression<br>
         - SSDEEP : Detected by judging similarity<br>
         - MD5 : Detected as hash value<br>
         - URL : Detected by URL<br>
         </small>
      </b-form-group>
      <b-card>
      <template slot="header">
         &lt;Table 1. WebShell Detect Information&gt;
      </template>
      <b-table hover striped small responsive="sm"  ref="_ch5" show-empty empty-text="not found"
        :items="rs_ch5" :fields="ch5" :current-page="1" :per-page="20" :sortBy="so.sk">
        <template slot="hash" slot-scope="row">{{row.item.hash}}</template>
        <template slot="detected_at" slot-scope="row">{{row.item.detected_at | date}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
      </b-table>
      </b-card>
      <b-card>
      <template slot="header">
         &lt;Table 2. Agent Check Table&gt;
      </template>
      <b-table hover striped small responsive="sm"  ref="_ch5" show-empty empty-text="not found"
        :items="rs_ch7" :fields="ch7" :current-page="1" :per-page="20" :sortBy="so.sk">
        <template slot="name" slot-scope="row">{{row.item.name}}</template>
        <template slot="scan_count" slot-scope="row">{{row.item.scan_count}}</template>
        <template slot="folder_count" slot-scope="row">{{row.item.folder_count}}</template>
        <template slot="detect_count" slot-scope="row">{{row.item.detect_count}}</template>
        <template slot="ip_adr" slot-scope="row">{{row.item.ip_adr}}</template>
      </b-table>
      </b-card>
    </div>
</template>

<script>

// import { idle } from '@/f1/service';
import CardBarChart from './CardBarChart';
import moment from 'moment-timezone';
// import custom from '@/f1/custom';
import DatePicker from 'vue2-datepicker';
import MainChart from './MainChart';
import { api } from '@/f1/service';
// import { code } from '@/f1/codes';


const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: true
});
let use_dataset = {
  labels: ['Use', 'UnUse'],
  datasets: [{
      label: 'Domain',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: []
    }]
}
let detect_dataset = {
  labels: ['의심', '경고', '위험', '주의'],
  datasets: [{
      label: '탐지 건수',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: []
    }]
}
let result_dataset = {
  labels: ['의심', '경고', '위험', '주의', '정상', '오류'],
  datasets: [{
      label: '점검 횟수',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: [78, 81, 80, 45, 45, 45]
    }]
}
// let rule_dataset = {
//   labels: ['URL', 'String', 'MD5', 'Regex'],
//   datasets: [{
//       label: 'Detect Rule',
//       backgroundColor: 'rgba(255,0,0,.3)',
//       borderColor: 'transparent',
//       data: [78, 81, 80, 45]
//     }]
// }
const bar_opt = {
  maintainAspectRatio: false,
  legend: { display: false },
  scales: {
    xAxes: [{ display: true, categoryPercentage: 1, barPercentage: 0.5 }],
    yAxes: [{ display: true }]
  }
}

export default {
  components: { DatePicker, MainChart, CardBarChart },
  data: () => {
    return {
      user : '',
      From: '',
      To: '',
      TT: '',
      FD: '',
      TD: '',
      model:{},
      bar_opt : bar_opt,
      // site_status : site_status,
      rs_ch9 : [],
      rs_ch11 : [],
      rs_ch7 : [],
      rs_ch8 : [],
      rs_ch12 : [],
      rs_ch10 : [],
      rs_ch5 : [],
      use_data : '',
      result_data : '',
      detect_data : '',
      rule_data : '',
      image2_data : null,
      image3_data : null,
      image4_data : null,

      detect : {
        summary : {
          H : 0,
        }
      },
      pattern : undefined,
      result : undefined,
      agent : { is_use : 0, unuse : 0},

      // add
      // user : {},
      // detect : { U : 0, S : 0, R : 0, H : 0 },
      // pattern : { system : { U : 0, S : 0, R : 0, H : 0 }, user : { U : 0, S : 0, R : 0, H : 0 } },
      // result : { total : 0 },
      server : { use : 0, unuse : 0},

      lan: datepicker,
      so : default_opt()
    }
  },
  computed: {
    ch7 : function(){ return[
        { key: 'name', label: 'Agent Name' },
        { key: 'scan_count', label: 'Scan Count' },
        { key: 'folder_count', label: 'Folder Count' },
        { key: 'detect_count', label: 'Detect Count' },
        { key: 'ip_addr', label: 'IP' },
      ]
    },
    ch5 : function() { return [
        { key: 'category', label: 'Category' },
        { key: 'hash', label: 'HASH' },
        { key: 'path', label: 'PATH' },
        { key: 'created_at', label: 'Detect Time' }
      ]
    },
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    }
  },
  methods: {
    printNow(value){
      this.print = value;
      this.$nextTick(() => {
      window.print();
      });
    },
    refresh() { this.$refs._list.refresh(); },
    report(){
      let m = {from : moment(this.From).format('YYYY-MM-DD'), to : moment(this.To).format('YYYY-MM-DD') }
        return api.WSFinder({target: 'report', cmd: 'report.web', request:'wsfinder', body : m, limit: 50 }).then(rs => {

        this.user = rs.body.summary.data.group;
        this.result = rs.body.summary.data.result;
        rs.body.summary.data.result.forEach(r => Object.keys(r).forEach(k => this.result[k] = r[k]));
        rs.body.summary.data.detect.forEach(r => this.detect[r.type] = r.count);
        rs.body.summary.data.pattern.system.forEach(r => this.pattern.system[r.type] = r.count);
        rs.body.summary.data.pattern.user.forEach(r => this.pattern.user[r.type] = r.count);
        this.server = {
          use : _.get(_.filter(rs.body.summary.data.server, { is_alive : true })[0], 'count') || 0,
          unuse : _.get(_.filter(rs.body.summary.data.server, { is_alive : false })[0], 'count') || 0
        };

        use_dataset.labels = ['Use', 'UnUse']
        use_dataset.datasets[0].data = [];
        use_dataset.datasets[0].data.push(this.server.use);
        use_dataset.datasets[0].data.push(this.server.unuse);
        this.use_data = _.cloneDeep(use_dataset);

        detect_dataset.labels = ['Regex', 'SSDEEP', 'Hash', 'URL']
        detect_dataset.datasets[0].data = [];
        detect_dataset.datasets[0].data.push(this.detect.Regex || 0);
        detect_dataset.datasets[0].data.push(this.detect.SSDEEP || 0);
        detect_dataset.datasets[0].data.push(this.detect.Hash || 0);
        detect_dataset.datasets[0].data.push(this.detect.URL || 0);
        this.detect_data = _.cloneDeep(detect_dataset);

        result_dataset.labels = ['Scan', 'Folder', 'Detect'];
        result_dataset.datasets[0].data = [];
        result_dataset.datasets[0].data.push(this.result.scan_count || 0)
        result_dataset.datasets[0].data.push(this.result.folder_count || 0)
        result_dataset.datasets[0].data.push(this.result.detect_count || 0)
        this.result_data = _.cloneDeep(result_dataset);

        this.rs_ch5 = rs.body.recent.data.detect;
        this.rs_ch7 = rs.body.recent.data.result;

        return this.model;
      })

      .then(() => {
        if(this.$refs._list) {
          this.$refs._list.refresh(); //표5
          this.$refs._list.refresh(); //표7
        }
        console.info("wsfinder report done");
        this.$toastr.i("done", "report loading")
      })
      .catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText));
    },
    reset() { this.refresh(); },
    hideList: function(e) {
      this.show = !e; console.log('report.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    }
  },
  created: function() {   console.log('report.vue', 'created'); },
  destroyed: function() { console.log('report.vue', 'destroyed'); },
  mounted: function() {
    this.From = location.hostname =="localhost" ? "2019-01-01" :  moment().format('YYYY-MM-DD');
    this.To = moment().format('YYYY-MM-DD');
    this.report();
    console.log('report.vue', 'mounted'); },
}
</script>
